import {Fragment, h} from "preact";
import s from "./inputV2.module.css";
import {useAppContext} from "../../contexts";

/**
 * A simple input component that can be used globally in the application.
 * Provides error messages support through the `error` property.
 * */
const InputV2 = props => {
    // Destructured component props
    const {
        type,
        label,
        name,
        handleChange,
        placeholder,
        value,
        // TODO: implement input types (e.g.: input | select | radio | checkbox)
        inputType = "input",
        error = undefined,
        isRequired = false,
        fieldsetClassName = undefined,
        labelClassName = undefined,
        className = undefined,
        dataTestId = null,
        subLabel = undefined,
        omitErrorMessage = true,
        // Any additional data that must be passed to the handler
        additionalData = undefined,
        options = undefined,
        ...rest
    } = props;

    // The variable name says it all
    const errorMessage = !omitErrorMessage && error && (
        <p className={`${s.errorMessage}`}>
            {error}
        </p>
    );

    // TODO: this is a WIP.
    //  We must componentize each of the types.
    // Formats the field to the desired input type
    const inputField =
        inputType === "select" && options ? (
            <select
                className={`
                            ${s.input} 
                            ${error
                    ? ` ${s.isInvalid}`
                    : (!error && value) ? ` ${s.isValid}` : ""
                } 
                            ${className}`
                }
                name={name}
                id={`${name}-input`}
                onInput={e => handleChange(e, additionalData)}
                value={value}
                {...rest}
            >
                <option value="">
                    Selecione aqui
                </option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        ) : (
            <input
                type={type}
                className={`
                            ${s.input} 
                            ${error
                    ? ` ${s.isInvalid}`
                    : (!error && value) ? ` ${s.isValid}` : ""
                } 
                            ${className}`
                }
                placeholder={placeholder}
                id={`${name}-input`}
                name={name}
                onInput={e => handleChange(e, additionalData)}
                value={value}
                {...rest}
                data-testid={dataTestId || 'generic-input'}
            />
        );

    return (
        <Fragment>
            <fieldset className={`${s.root} ${fieldsetClassName}`}>
                <label
                    htmlFor={`${name}-input`}
                    className={`${s.label} ${labelClassName}`}
                    data-testid="generic-input-label"
                >
                    {label}&nbsp;
                    <span
                        className={`${!isRequired ? "hidden" : ""} !text-sabin-red-default`}
                        data-testid="generic-input-required-label"
                    >
                        *
                    </span>
                    <span
                        className={`${!subLabel ? "hidden" : ""}`}
                        data-testid="generic-input-required-label"
                    >
                        &nbsp;&nbsp;{subLabel}
                    </span>
                </label>
                <div className={"relative w-full"}>
                    {inputField}
                </div>
                {errorMessage}
            </fieldset>
        </Fragment>
    )
}

export default InputV2;
